import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Font Awesome CSS
import './tailwind.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
// react-helmet's current release uses a legacy lifecycle that emits a
// React 19 StrictMode warning. Keep a single root render so the admin login
// remains usable during local development; production behavior is unchanged.
root.render(<App />);
